export interface RetreatLeader {
    name: string,
    bio?: string,
}

export interface RetreatSession {
    from: string,
    to: string,
    title?: string,
    topic?: string,
    note?: string,
    leader?: RetreatLeader,
}

export interface RetreatCenter {
    id: string,
    name: string,
    place: string,
    intro?: string[],
    topic?: {quote: string, source: string, subtitle?: string},
    leader?: RetreatLeader,
    description?: string,
    schedule?: string[],
    sessions: RetreatSession[],
    signup?: {label: string, phones: string[]},
    website?: string,
}

const dutko: RetreatLeader = {
    name: "ks. Bohdan Dutko MS",
    bio: "Urodzony w 1962 r. Studiował w Wyższym Seminarium Duchownym Saletynów w Krakowie. Święcenia kapłańskie przyjął " +
        "w 1988 r. Studiował na Papieskim Uniwersytecie Salezjańskim w Rzymie. Przez długie lata redaktor naczelny " +
        "dwumiesięcznika „Posłaniec Matki Bożej Saletyńskiej”. Duszpasterz w Olsztynie i w Rzeszowie (duszpasterz " +
        "akademicki i proboszcz). Autor książek i artykułów; prowadzi rekolekcje zakonne, kapłańskie i parafialne; " +
        "dyrektor „Centrum Pojednania” w Dębowcu, przełożony wspólnoty międzynarodowej w Rzymie. Od 2025 r. przełożony " +
        "wspólnoty zakonnej i dyrektor Domu Rekolekcyjnego „Maleńka” w Zakopanem.",
};

const mastalski: RetreatLeader = {
    name: "bp prof. Janusz Mastalski",
    bio: "Biskup pomocniczy krakowski, profesor nauk teologicznych; wcześniej był dziekanem Wydziału Nauk Społecznych " +
        "UPJPII oraz rektorem WSD.",
};

export const retreatCenters: RetreatCenter[] = [
    {
        id: "domus-mater",
        name: "Domus Mater",
        place: "Kraków",
        intro: [
            "W ramach propozycji duszpasterskiej pragniemy serdecznie zaprosić Księży do Domus Mater w Krakowie " +
            "na organizowane już po raz kolejny kapłańskie rekolekcje.",
            "Codzienność kapłańską często wypełnia troska o innych, o powierzonych nam wiernych, zapominając, że " +
            "najpierw mam zbawić siebie. Rekolekcje to zatrzymanie, to zostawienie na chwilę wszystkiego obok. " +
            "Rekolekcje to czas odnowienia w sercu i umyśle pragnień, jakie w sobie noszę, zobaczenie, czy wśród nich " +
            "jest to najważniejsze — pragnienie życia wiecznego.",
        ],
        topic: {
            quote: "W Nim bowiem żyjemy, poruszamy się i jesteśmy",
            source: "Dz 17,28",
            subtitle: "Kapłan – człowiek uwielbienia, obecności i komunii",
        },
        leader: {
            name: "ks. Franciszek Wielgut",
            bio: "Sercanin, mgr lic. nauk biblijnych, absolwent Wyższego Seminarium Misyjnego Księży Sercanów " +
                "w Stadnikach, Uniwersytetu Papieskiego Jana Pawła II w Krakowie oraz Instytutu Nauk Biblijnych " +
                "Katolickiego Uniwersytetu Lubelskiego Jana Pawła II w Lublinie. Na co dzień zaangażowany " +
                "w duszpasterstwo powołaniowe i młodzieżowe. Koordynuje Sercańskie Rekolekcje Młodzieżowe oraz " +
                "posługuje jako duszpasterz wspólnoty Jireh dla osób stanu wolnego.",
        },
        sessions: [
            {from: "2026-10-19", to: "2026-10-22"},
            {from: "2026-11-09", to: "2026-11-12"},
            {from: "2026-11-16", to: "2026-11-19"},
            {from: "2026-11-23", to: "2026-11-26"},
            {from: "2026-11-30", to: "2026-12-03"},
        ],
        signup: {label: "Zapisy w recepcji", phones: ["12 290 63 01"]},
        website: "https://domusmater.pl/",
    },
    {
        id: "eccc",
        name: "Europejskie Centrum Komunikacji i Kultury",
        place: "Warszawa-Falenica",
        intro: [
            "Europejskie Centrum Komunikacji i Kultury zaprasza księży na rekolekcje poruszające temat uważnego " +
            "(synodalnego) towarzyszenia w duszpasterstwie, które prowadzi do relacji „w zdrowym rytmie bliskości” " +
            "(papież Franciszek).",
        ],
        sessions: [
            {from: "2026-11-09", to: "2026-11-12", leader: {name: "o. Maciej Biskup OP"}},
        ],
        website: "https://eccc.pl",
    },
    {
        id: "lichen",
        name: "Dom Papieski Sanktuarium Matki Bożej Licheńskiej",
        place: "Licheń",
        description: "Katechezy, wspólnie sprawowana codziennie Eucharystia, adoracja Najświętszego Sakramentu, " +
            "a jednocześnie czas na własną refleksję, lekturę czy spacer.",
        schedule: [
            "Rozpoczęcie: poniedziałek, godz. 19.00",
            "Zakończenie: czwartek, godz. 13.30",
        ],
        sessions: [
            {from: "2026-11-19", to: "2026-11-21", leader: {name: "ks. Piotr Kieniewicz MIC"}},
        ],
        signup: {label: "Zgłoszenia", phones: ["63 270 81 42", "63 270 81 63"]},
    },
    {
        id: "ksiezowka",
        name: "Księżówka",
        place: "Zakopane",
        sessions: [
            {
                from: "2026-10-05", to: "2026-10-08", note: "pod patronatem Materiałów Homiletycznych",
                leader: {
                    name: "ks. dr Tomasz Bajer",
                    bio: "Homileta i rekolekcjonista, proboszcz parafii pw. Pana Jezusa Dobrego Pasterza w Sygneczowie.",
                },
            },
            {
                from: "2026-10-12", to: "2026-10-15", note: "pod patronatem Materiałów Homiletycznych",
                leader: {
                    name: "ks. dr Marcin Cholewa",
                    bio: "Doktor psychologii, wykładowca UPJPII w Krakowie.",
                },
            },
            {from: "2026-10-26", to: "2026-10-29", leader: mastalski},
            {
                from: "2026-11-04", to: "2026-11-07", note: "Diecezja Bydgoska",
                leader: {
                    name: "ks. Sławomir Bar CM",
                    bio: "Superior domu zakonnego w Bydgoszczy, proboszcz parafii św. Wincentego a Paulo w Bydgoszczy, " +
                        "opiekun bezdomnych.",
                },
            },
            {
                from: "2026-11-11", to: "2026-11-14", note: "Diecezja Bydgoska",
                leader: {
                    name: "ks. dr Paweł Hoppe",
                    bio: "Dyrektor Centrum Edukacyjno-Formacyjnego, były ojciec duchowny seminarium, historyk Kościoła.",
                },
            },
            {
                from: "2026-11-16", to: "2026-11-19", note: "Diecezja Bydgoska",
                leader: {
                    name: "ks. dr Piotr Wachowski",
                    bio: "Dyrektor Wydziału Duszpasterskiego Kurii, duszpasterz akademicki, proboszcz w Fordonie.",
                },
            },
            {
                from: "2026-11-19", to: "2026-11-21", note: "Dominikański Ośrodek Liturgiczny",
                leader: {
                    name: "o. Dawid Kołodziejczyk OP",
                    bio: "Pracuje w Dominikańskim Ośrodku Liturgicznym i prowadzi autorski podcast „Puzzle Wiary”; " +
                        "uwielbia góry i spotkania z ludźmi.",
                },
            },
            {
                from: "2026-11-26", to: "2026-11-28", note: "Dominikański Ośrodek Liturgiczny",
                leader: {
                    name: "o. Łukasz Miśko OP",
                    bio: "Dyrektor Dominikańskiego Ośrodka Liturgicznego, przez 10 lat duszpasterz w USA, rozmiłowany " +
                        "w muzyce liturgicznej i szlakach Camino.",
                },
            },
            {from: "2026-11-30", to: "2026-12-03", leader: mastalski},
            {
                from: "2026-12-07", to: "2026-12-10", note: "Diecezja Bydgoska",
                leader: {
                    name: "o. dr Marek Walkusz CSSp",
                    bio: "Duchacz, wieloletni misjonarz w Afryce, rektor kościoła w domu prowincjalnym.",
                },
            },
            {
                from: "2026-12-14", to: "2026-12-17", note: "Diecezja Bydgoska",
                leader: {
                    name: "ks. Tomasz Cyl",
                    bio: "Wikariusz generalny, wieloletni dyrektor szkoły katolickiej, proboszcz w Bydgoszczy.",
                },
            },
            {
                from: "2027-02-15", to: "2027-02-18", note: "Wielkopostna seria biblijna",
                leader: {
                    name: "ks. prof. Waldemar Chrostowski",
                    bio: "Biblista, konsultor Rady KEP ds. Dialogu Religijnego, profesor zwyczajny UKSW, zaangażowany " +
                        "w dialog katolicko-żydowski.",
                },
            },
        ],
        website: "https://www.ksiezowka.zakopane.pl/rekolekcje-kaplanskie/",
    },
    {
        id: "malenka",
        name: "Dom Rekolekcyjny „Maleńka” – Saletyni",
        place: "Zakopane",
        sessions: [
            {from: "2026-10-25", to: "2026-10-28", title: "Seria I", leader: dutko},
            {
                from: "2026-11-02", to: "2026-11-05", title: "Seria II",
                leader: {
                    name: "ks. Kazimierz Wolan MS",
                    bio: "Urodzony w 1960 roku w Gliniku Zaborowskim. Studiował w Wyższym Seminarium Duchownym Saletynów " +
                        "w Krakowie. Święcenia kapłańskie przyjął w 1987 roku. Pełnił posługi duszpasterskie jako " +
                        "proboszcz w Warszawie i Krakowie. Rektor i ojciec duchowny w WSD Misjonarzy Saletynów. " +
                        "Wieloletni rekolekcjonista i spowiednik. Posługiwał w Domu Rekolekcyjnym „Centrum Pojednania” " +
                        "w Dębowcu. Obecnie posługuje w Domu Rekolekcyjnym „Maleńka” w Zakopanem.",
                },
            },
            {
                from: "2026-11-16", to: "2026-11-19", title: "Seria III",
                leader: {
                    name: "ks. Marcin Sitek MS",
                    bio: "Urodził się w 1983 r. w Rzeszowie. Święcenia kapłańskie przyjął 16.05.2009 r. Przełożony " +
                        "wspólnoty zakonnej i kustosz sanktuarium Matki Bożej Saletyńskiej w Dębowcu. Posługiwał " +
                        "w parafiach w Trzciance i Olsztynie. Pełnił funkcję dyrektora postulatu. Absolwent pedagogiki " +
                        "na Papieskim Uniwersytecie Salezjańskim w Rzymie, rekolekcjonista, duszpasterz.",
                },
            },
            {
                from: "2026-11-23", to: "2026-11-26", title: "Seria IV",
                leader: {
                    name: "bp Radosław Zmitrowicz OMI",
                    bio: "Urodził się w 1962 roku. W 1981 roku wstąpił do Zgromadzenia Misjonarzy Oblatów Maryi " +
                        "Niepokalanej. Święcenia kapłańskie przyjął 17 czerwca 1989 roku. Posługiwał w Polsce " +
                        "(Poznań, Markowice), a następnie jako misjonarz w Turkmenistanie (1997–2000). Od 2000 roku " +
                        "posługuje na Ukrainie (m.in. w Czernihowie i Kijowie), gdzie pełnił funkcję superiora " +
                        "delegatury oblackiej. 29 listopada 2012 roku papież Benedykt XVI mianował go biskupem " +
                        "pomocniczym diecezji kamienieckiej. Sakrę biskupią przyjął 9 lutego 2013 roku. W Konferencji " +
                        "Episkopatu Ukrainy odpowiada za duszpasterstwo rodzin. Jest zaangażowany w pomoc ofiarom " +
                        "trwającej wojny. Ukończył formację Drogi Neokatechumenalnej. Znany i ceniony rekolekcjonista.",
                },
            },
            {from: "2026-11-30", to: "2026-12-03", title: "Seria V", leader: {name: dutko.name}},
        ],
        website: "https://drmalenka.saletyni.pl/rekolekcje-i-turnusy/rekolekcje-kaplanskie/",
    },
    {
        id: "gietrzwald",
        name: "Domus Mariae",
        place: "Gietrzwałd",
        sessions: [
            {
                from: "2026-10-13", to: "2026-10-15",
                topic: "Oto Matka twoja. Nowotestamentowy wizerunek Maryi",
                leader: {name: "ks. prof. Waldemar Chrostowski"},
            },
            {
                from: "2026-11-09", to: "2026-11-11",
                topic: "Dla kapłanów – duchowość i posługa",
                leader: {name: "o. Robert Bujak SJ"},
            },
        ],
        website: "https://domusmariae.eu/rekolekcje/",
    },
];
